import React, {lazy, useContext} from 'react';
import './Faq.css';
import { LocaleContext } from '../common/App';
import { Footer } from './WebsiteCommon';
import { DropdownInfo, LinkSmart } from '../common/Common';
import { Link, useSearchParams } from 'react-router-dom';

const ImprintDe = lazy(() => import('./de/ImprintDe'));

export function Faq(props) {
    const locale = useContext(LocaleContext);

    const [searchParams, setSearchParams] = useSearchParams();

    // Get the value of the query parameter you're interested in  
    const questionNoToOpen = searchParams.get("question");

    return (
        <div>
            <div className="bottom_padding_high side_padding flex_col">
                <div className="text_small">{locale.msgs.FAQ}</div>


                <div className="text_big_big margin_top_low">{locale.msgs.FAQ_HEAD_1}</div>

                <div className="faq_question_box">

                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_1} open={questionNoToOpen == 1} answer={locale.msgs.FAQ_ANSWER_1} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_2} open={questionNoToOpen == 2} answer={locale.msgs.FAQ_ANSWER_2} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_3} open={questionNoToOpen == 3} rawAnswer={
                            <div style={{cursor: "default"}}>
                                <span dangerouslySetInnerHTML={{__html: locale.msgs.FAQ_ANSWER_3}} />
                                <LinkSmart className="text_small_small link_2" to={"/families"} target="_blank">{locale.msgs.TO_MEDIATION_PROCESS}</LinkSmart>
                            </div>
                    } />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_4} open={questionNoToOpen == 4} answer={locale.msgs.FAQ_ANSWER_4} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_5} open={questionNoToOpen == 5} answer={locale.msgs.FAQ_ANSWER_5} />

                </div>


                <div className="text_big_big margin_top_mid_high">{locale.msgs.FAQ_HEAD_2}</div>

                <div className="faq_question_box">

                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_6} open={questionNoToOpen == 6} answer={locale.msgs.FAQ_ANSWER_6} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_7} open={questionNoToOpen == 7} answer={locale.msgs.FAQ_ANSWER_7} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_8} open={questionNoToOpen == 8} answer={locale.msgs.FAQ_ANSWER_8} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_9} open={questionNoToOpen == 9} answer={locale.msgs.FAQ_ANSWER_9} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_10} open={questionNoToOpen == 10} rawAnswer={
                            <div style={{cursor: "default"}}>
                                <span dangerouslySetInnerHTML={{__html: locale.msgs.FAQ_ANSWER_10}} />
                                <LinkSmart className="text_small_small link_2" to={"/families"} target="_blank">{locale.msgs.TO_MEDIATION_PROCESS}</LinkSmart>
                            </div>
                    } />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_11} open={questionNoToOpen == 11} answer={locale.msgs.FAQ_ANSWER_11} />

                </div>


                <div className="text_big_big margin_top_mid_high">{locale.msgs.FAQ_HEAD_3}</div>

                <div className="faq_question_box">

                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_12} open={questionNoToOpen == 12} answer={locale.msgs.FAQ_ANSWER_12} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_13} open={questionNoToOpen == 13} answer={locale.msgs.FAQ_ANSWER_13} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_14} open={questionNoToOpen == 14} answer={locale.msgs.FAQ_ANSWER_14} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_15} open={questionNoToOpen == 15} answer={locale.msgs.FAQ_ANSWER_15} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_16} open={questionNoToOpen == 16} answer={locale.msgs.FAQ_ANSWER_16} />

                </div>


                <div className="text_big_big margin_top_mid_high">{locale.msgs.FAQ_HEAD_4}</div>

                <div className="faq_question_box">

                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_17} open={questionNoToOpen == 17} answer={locale.msgs.FAQ_ANSWER_17} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_18} open={questionNoToOpen == 18} answer={locale.msgs.FAQ_ANSWER_18} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_19} open={questionNoToOpen == 19} answer={locale.msgs.FAQ_ANSWER_19} />

                </div>


                <div className="text_big_big margin_top_mid_high">{locale.msgs.FAQ_HEAD_5}</div>

                <div className="faq_question_box">

                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_20} open={questionNoToOpen == 20} answer={locale.msgs.FAQ_ANSWER_20} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_21} open={questionNoToOpen == 21} answer={locale.msgs.FAQ_ANSWER_21} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_22} open={questionNoToOpen == 22} answer={locale.msgs.FAQ_ANSWER_22} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_23} open={questionNoToOpen == 23} answer={locale.msgs.FAQ_ANSWER_23} />

                </div>


                <div className="text_big_big margin_top_mid_high">{locale.msgs.FAQ_HEAD_6}</div>

                <div className="faq_question_box">

                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_24} open={questionNoToOpen == 24} answer={locale.msgs.FAQ_ANSWER_24} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_25} open={questionNoToOpen == 25} answer={locale.msgs.FAQ_ANSWER_25} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_26} open={questionNoToOpen == 26} answer={locale.msgs.FAQ_ANSWER_26} />
                    <FaqQuestion question={locale.msgs.FAQ_QUESTION_27} open={questionNoToOpen == 27} answer={locale.msgs.FAQ_ANSWER_27} />

                </div>
            </div>

            <Footer />
        </div>
    );
}

const FaqQuestion = ({question, answer, rawAnswer, open}) => {
    return(
        <DropdownInfo success={false} open={open ? true : false} minimal={false} noCircle={true} noMargin={true} scrollToTop={true}
                /*recalcTrigger={dropdownRecalcTrigger}*/
                /*name={ <div style={{fontWeight: 600}}>{locale.msgs.INFORMATION}</div>} */
                name={
                    <div className="faq_question_name">
                        <img src="/customer/icon_faq.svg" />
                        <div className="faq_question_text" dangerouslySetInnerHTML={{__html: question}}></div>
                    </div>
                }
                content={!rawAnswer ? (<div dangerouslySetInnerHTML={{__html: answer}}></div>) : rawAnswer}
        />
    );
}
